// src/hooks/useLogout.ts
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { PURGE } from 'redux-persist';
import { useWeb3Auth } from '../auth/Web3AuthContext';
import { setAuthenticated } from '../store/slices/authSlice';
import { logOut } from '../store/slices/userSlice';
import { cleanupBalanceSubscription } from '../store/slices/balanceSlice';
import { WITHDRAW_PROGRESS_KEY, PENDING_GUARDARIAN_WITHDRAW_KEY, PENDING_OFF_RAMP_KEY } from '../services/WithdrawService';

export const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { logout: web3authLogout } = useWeb3Auth();

  const logout = async () => {
    try {
      // First handle Web3Auth logout
      await web3authLogout();

      // Clear withdrawal-related localStorage to prevent state leaking to next user
      localStorage.removeItem(WITHDRAW_PROGRESS_KEY);
      localStorage.removeItem(PENDING_GUARDARIAN_WITHDRAW_KEY);
      localStorage.removeItem(PENDING_OFF_RAMP_KEY);

      // Clean up balance subscription before clearing state
      cleanupBalanceSubscription();

      // Then handle Redux state cleanup
      dispatch(setAuthenticated(false));
      dispatch(logOut());
      
      // Correct way to dispatch PURGE action
      dispatch({
        type: PURGE,
        key: 'root',
        result: () => null // Add this line
      });

      // Finally navigate
      navigate('/SignIn');
    } catch (error) {
      console.error('Logout error:', error);
      // You might want to handle the error appropriately
      // Perhaps show a notification to the user
    }
  };

  return logout;
};